import {createSelector} from 'reselect';
import props from '../../../props';

export default createSelector(
    props.tasks.tasks.general.phone,
    (task) => {
        return {
            task
        }
    }
)